import { WORK_DATA } from "./work.data";

const INITIAL_STATE = {
  projects: WORK_DATA,
};

const projectReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default projectReducer;
